import { c as _c } from "react/compiler-runtime";
import { Box, HStack, Text, VStack, chakra } from '@chakra-ui/react';
import { CrmLabel } from '@src/components/sco/Admin/AiCrm/ui/CrmType';
import React, { type ReactNode } from 'react';

/**
 * The left pane of every two-pane page: a title and a line of help, then a list that scrolls
 * on its own. One shell so Rules, Templates, Live runs, and Cards read as the same product.
 */
export function CrmListPane(props) {
  const $ = _c(26);
  const t0 = props.tabs ? 0 : "1px";
  const t1 = props.tabs ? 0 : 4;
  let t2;
  if ($[0] !== props.title) {
    t2 = <Text fontSize="lg" fontWeight="bold">{props.title}</Text>;
    $[0] = props.title;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== props.action || $[3] !== t2) {
    t3 = <HStack gap={3} justify="space-between">{t2}{props.action}</HStack>;
    $[2] = props.action;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== props.notice) {
    t4 = props.notice ? <Box mt={1.5}>{props.notice}</Box> : null;
    $[5] = props.notice;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== props.sub) {
    t5 = props.sub ? <Text color="fg.muted" fontSize="sm" lineHeight="1.5" mt={1.5}>{props.sub}</Text> : null;
    $[7] = props.sub;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== props.head) {
    t6 = props.head ? <Box mt={3}>{props.head}</Box> : null;
    $[9] = props.head;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== props.tabs) {
    t7 = props.tabs ? <Box borderBottomWidth="1px" borderColor="border" mt={3} mx={-4} px={4}>{props.tabs}</Box> : null;
    $[11] = props.tabs;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t0 || $[14] !== t1 || $[15] !== t3 || $[16] !== t4 || $[17] !== t5 || $[18] !== t6 || $[19] !== t7) {
    t8 = <Box borderBottomWidth={t0} borderColor="border" flexShrink={0} pb={t1} pt={4} px={4}>{t3}{t4}{t5}{t6}{t7}</Box>;
    $[13] = t0;
    $[14] = t1;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== props.children) {
    t9 = <Box flex="1" minH={0} overflowY="auto" px={2} py={2}>{props.children}</Box>;
    $[21] = props.children;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t8 || $[24] !== t9) {
    t10 = <VStack align="stretch" bg="colorPalette.bg" gap={0} h="full" minH={0}>{t8}{t9}</VStack>;
    $[23] = t8;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
}
export function CrmListGroup(props) {
  const $ = _c(7);
  let t0;
  if ($[0] !== props.title) {
    t0 = <CrmLabel>{props.title}</CrmLabel>;
    $[0] = props.title;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.note) {
    t1 = props.note ? <Text color="fg.subtle" fontSize="2xs">{props.note}</Text> : null;
    $[2] = props.note;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = <HStack gap={2} pb={1.5} pt={4} px={2.5}>{t0}{t1}</HStack>;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}

/** One selectable row. A yellow edge marks the open one, as in the handoff. */
export function CrmListRow(props) {
  const $ = _c(17);
  const t0 = props.selected ? undefined : "colorPalette.container/40";
  let t1;
  if ($[0] !== t0) {
    t1 = {
      bg: t0
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = props.selected ? "true" : undefined;
  const t3 = props.selected ? "colorPalette.container" : "transparent";
  const t4 = props.selected ? "yellow.solid" : "transparent";
  const t5 = props.dim && !props.selected ? 0.55 : 1;
  const t6 = props.selected ? "fg" : "fg.muted";
  let t7;
  if ($[2] !== props.title || $[3] !== t6) {
    t7 = <Text color={t6} flex="1" fontSize="sm" fontWeight="bold" lineClamp={1} minW={0}>{props.title}</Text>;
    $[2] = props.title;
    $[3] = t6;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] !== props.right) {
    t8 = props.right ? <HStack flexShrink={0} gap={1.5}>{props.right}</HStack> : null;
    $[5] = props.right;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== props.icon || $[8] !== props.onSelect || $[9] !== t1 || $[10] !== t2 || $[11] !== t3 || $[12] !== t4 || $[13] !== t5 || $[14] !== t7 || $[15] !== t8) {
    t9 = <chakra.button _hover={t1} alignItems="center" aria-current={t2} bg={t3} borderLeftColor={t4} borderLeftWidth="2px" borderRadius="lg" cursor="pointer" display="flex" gap={2.5} mb={0.5} opacity={t5} pl={2.5} pr={2.5} py={2} textAlign="left" type="button" w="full" onClick={props.onSelect}>{props.icon}{t7}{t8}</chakra.button>;
    $[7] = props.icon;
    $[8] = props.onSelect;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
}